import React from 'react';
import { Controller } from 'react-hook-form';

import useTranslate from '@src/i18n/useTranslate';

import CodeInput from '@src/components/ui2/CodeInput';
import { RenderProps } from './Form';
import usePhoneVerification from '@src/features/customers/auth/phone-verification/hooks/usePhoneVerification';

interface PhoneVerificationCodeInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'name' | 'form'>,
    RenderProps {
  label?: string;
}

const Input = (props: PhoneVerificationCodeInputProps) => {
  const { defaultValue, label, form, ...restOfProps } = props;

  const { i18n } = useTranslate();
  const { loading } = usePhoneVerification();

  return (
    <Controller
      name='code'
      control={form.control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value, name, ...rest } }) => (
        <CodeInput
          {...restOfProps}
          value={value}
          onChange={(e) => onChange(e)}
          label={label ?? i18n('direct_link_phone_verification_form_code_label')}
          name={name}
          error={!!form.formState.errors[name]}
          helperText={form.formState.errors[name]?.message as string}
          disabled={loading}
          {...rest}
        />
      )}
    />
  );
};

export default Input;
